export function getRequestConfig(headers?) {
  const config = {
    headers: {
      Authorization: sessionStorage.getItem('ZervantSession'),
      'Content-Type': 'application/json',
    },
  }

  if (headers) {
    config.headers = Object.assign({}, config.headers, headers)
  }
  return config
}
